import { Badge, BadgeProps } from '@quality24/design-system';
import { EnumPaymentRequestStatus } from '@quality24/inpatient-typings';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
  className?: string;
  status: EnumPaymentRequestStatus;
}

export const paymentStatusMap: Record<
  EnumPaymentRequestStatus,
  { label: string; variant: BadgeProps['variant'] }
> = {
  PENDING: { label: 'payment.status.awaitingPayment', variant: 'info' },
  PAID: { label: 'payment.status.paid', variant: 'success' },
  DENIED: { label: 'payment.status.denied', variant: 'danger' },
  EXPIRED: { label: 'payment.status.expired', variant: 'info-dark' },
  VOIDED: { label: 'payment.status.voided', variant: 'info-dark' },
  NOT_FINALIZED: { label: 'payment.status.notCompleted', variant: 'info-dark' },
  AUTHORIZED: { label: 'payment.status.authorized', variant: 'success' },
  CHARGEBACK: { label: 'payment.status.refund', variant: 'info-dark' },
};

const PaymentStatusBadge: React.FunctionComponent<Props> = ({
  className,
  status,
}) => {
  const { t } = useTranslation();
  return (
    <Badge
      className={className}
      variant={paymentStatusMap[status]?.variant}
      weight="semiBold"
    >
      {paymentStatusMap[status]?.label && t(paymentStatusMap[status].label)}
    </Badge>
  );
};

export default PaymentStatusBadge;
